import { combineReducers } from "@reduxjs/toolkit";
import sideMenuSlice from "./sideMenuSlice";
import tabsStateSlice from './tabStateSlice';

export default combineReducers({
    tabsStateSlice,
    sideMenuSlice
});
